import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveFolderRequestFailure({ uuid }) {
      const req = getState().find(({ folder }) => folder.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRemoveFolderRequestPending({ uuid }) {
      const req = getState().find(({ folder }) => folder.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRemoveFolderRequestSuccess({ uuid }) {
      const req = getState().find(({ folder }) => folder.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
